module.exports = __webpack_public_path__ + "img/logo_gen.e89c8089.svg";